/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import styled from "styled-components";
import Button from "../Button";
import {
  DiscordSVG,
  FacebookSVG,
  InstagramSVG,
  LinkedinSVG,
  MediumSVG,
  TelegramSVG,
  TwitterSVG,
  YoutubeSVG,
} from "../../utils/svgs";

const Community = () => {
  const socials = [
    {
      link: "https://twitter.com/TrueapexFi?t=u4x5Yjtexb4Fai8NBug5wg&s=09",
      icon: TwitterSVG,
    },
    {
      link: "https://medium.com/@trueapexfinance_55238",
      icon: MediumSVG,
    },
    // {
    //   link: "#",
    //   icon: LinkedinSVG,
    // },
    // {
    //   link: "#",
    //   icon: InstagramSVG,
    // },
    // {
    //   link: "#",
    //   icon: YoutubeSVG,
    // },
  ];
  return (
    <div className="w-full h-[544px] relative px-3 dark:bg-primary bg-white dark:text-white text-primary dark:bg-[url('/public/images/footer/back-dark.png')] bg-cover bg-[url('/public/images/footer/back-light.png')]">
      <div className="flex xl:justify-between justify-center items-center w-full max-w-[1362px] mx-auto relative z-10 h-full xl:flex-row flex-col">
        <div>
          <div className="md:xs:text-[50px] xs:text-[40px] text-[32px] font-semibold">
            Join Our Community
          </div>
          <div className="font-medium xs:text-xl text-base mt-8 max-w-[450px]">
            Become part of a family and share in profits airdrops, deals, and giveaways.
          </div>
          <div className="flex items-center sm:mt-[63px] mt-10 sm:flex-row flex-col">
            <a href={"https://discord.gg/Zr6nGnks"} target={"_blank"} rel="noreferrer">
              <Button
                type={"primary"}
                className="md:w-[327px] w-[280px] xs:h-[55px] h-[45px] rounded-[30px] text-[15px] font-bold"
              >
                <div className="flex items-center">
                  <div className="mr-3 xs:scale-100 scale-[80%]">{DiscordSVG}</div>
                  <div className="xs:text-base text-sm">JOIN DISCORD</div>
                </div>
              </Button>
            </a>
            <div className="sm:mr-9 mr-0 sm:mt-0 mt-4" />
            <a href={"https://t.me/+wK4yrUaH7c84YjA5"} target="_blank" rel="noreferrer">
              <Button
                type={"primary"}
                className="md:w-[327px] w-[280px] xs:h-[55px] h-[45px]  rounded-[30px] text-[15px] font-bold"
              >
                <div className="flex items-center">
                  <div className="mr-3 xs:scale-100 scale-[80%]">{TelegramSVG}</div>
                  <div className="xs:text-base text-sm">JOIN TELEGRAM</div>
                </div>
              </Button>
            </a>
          </div>
        </div>
        <div className="flex xl:mt-0 mt-10">
          {socials.map((data, i) => {
            return (
              <a
                key={i}
                className="md:xs:w-20 md:xs:h-20 xs:w-16 xs:h-16 w-12 h-12 rounded-full flex items-center justify-center bg-white dark:bg-primary dark:text-white text-green mr-3 hover:scale-[110%] transition-all duration-300"
                href={data.link}
                target="_blank"
                rel="noreferrer"
              >
                <div className="md:xs:scale-100 xs:scale-[80%] scale-[65%]">{data.icon}</div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Community;
